import React from 'react';
import classNames from 'classnames';
import SvgIcon from './icons/SvgIcon';
const CheckableBox = ({ className, onClick, children, checked, block, checkboxPosition }) => (<button onClick={onClick} className={classNames('checkable-box', className, {
        'checkable-box--checked': checked,
    }, {
        'checkable-box--block': block,
    })}>
        {children}
        <SvgIcon kind={checked === true ? 'Checkbox' : 'CheckboxEmpty'} className={classNames(`checkable-box__icon`, `checkable-box__icon--${checkboxPosition}`)}/>
    </button>);
CheckableBox.defaultProps = {
    className: '',
    checked: false,
    block: false,
    onClick: () => undefined,
    checkboxPosition: 'right-top',
};
export default CheckableBox;
